import React, { useEffect, useCallback, useState } from "react";
import { Table, Drawer } from "antd";
import { MdEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteProduction,
  getallProduction,
  setTableData,
} from "../store/dataSlice";
import {
  setSelectedprod,
  setSelectedProduction,
  toggleNewEditDialog,
} from "../store/stateSlice";
import { toggleNewDialog } from "../store/stateSlice";
import ProductionForm from "./ProductionForm";
import ProductionDetail from "./ProductionDetail";

const ProductionTablemain = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const dispatch = useDispatch();
  const tableData = useSelector((state) => state.production.data.tableData);
  const { pageIndex = 1, pageSize = 10 } = tableData || {};
  const data = useSelector(
    (state) => state.production.data.productionList?.data
  );
  const loading = useSelector((state) => state.production.data.loading);
  const edit = useSelector((state) => state.production.state.editDialog);
  const handleClose = () => {
    dispatch(toggleNewEditDialog(false)); // Close the modal
  };
  const openDrawer = (record) => {
    setSelectedRecord(record);
    setDrawerVisible(true);
  };
  const closeDrawer = () => {
    setDrawerVisible(false);
  };
  const fetchData = useCallback(() => {
    dispatch(getallProduction({ pageIndex, pageSize }));
  }, [pageIndex, pageSize]);
  useEffect(() => {
    fetchData();
  }, [pageIndex, pageSize]);
  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;

    dispatch(setTableData({ pageIndex: current, pageSize: pageSize }));
  };

  const onEdit = (record) => {
    dispatch(setSelectedprod(record));
    dispatch(toggleNewEditDialog(true));
  };
  const onDelete = (record) => {
    dispatch(
      deleteProduction({
        production_plan_id: record.production_plan_id,
      })
    );
    dispatch(getallProduction());
  };
  const columns = [
    {
      title: <span className="text-gray-500">Action</span>,
      dataIndex: "action",
      width: 100,
      fixed: "left",
      render: (_, record) => (
        <div className="flex items-center">
          <span
            onClick={() => onEdit(record)}
            className="text-2xl text-[#096CAE] cursor-pointer"
          >
            <MdEdit />
          </span>
          <span
            onClick={() => onDelete(record)}
            className="text-2xl text-[#cf1623] cursor-pointer"
          >
            <MdDelete />
          </span>
        </div>
      ),
    },
    {
      title: <span className="text-gray-500">Production plan number</span>,
      dataIndex: "production_plan_number",
      width: 150,
      render: (text, record) => (
        <div
          onClick={() => openDrawer(record)}
          className="cursor-pointer hover:font-extrabold delay-150"
        >
          {text}
        </div>
      ),
    },
    {
      title: <span className="text-gray-500">Order no</span>,
      dataIndex: ["Po", "order_number"],
      width: 150,
    },
    {
      title: <span className="text-gray-500">Employee Name</span>,
      dataIndex: "employees",
      width: 150,
    },

    {
      title: <span className="text-gray-500">Completion Date</span>,
      dataIndex: "completion_date",
      width: 150,
    },

    {
      title: <span className="text-gray-500">Status</span>,
      dataIndex: "status",
      width: 150,
      render: (status) => (
        <button
          style={{
            color: "white",
            backgroundColor: status === "Accept" ? "green" : "red",
            padding: "2px",
            borderRadius: "4px",
          }}
        >
          {status === "pending" ? "Pending" : status}
        </button>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: 1500 }}
        bordered
        loading={loading}
        onChange={handleTableChange}
        pagination={{
          current: pageIndex,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: [5, 10, 20],
          onShowSizeChange: handleTableChange,
        }}
      />
      <Drawer
        title="Add Production"
        onClose={handleClose}
        open={edit}
        width={1500}
      >
        <ProductionForm type={"edit"} />
      </Drawer>
      <Drawer
        title="Details"
        width={1500}
        onClose={closeDrawer}
        open={drawerVisible}
      >
        <ProductionDetail record={selectedRecord} />
      </Drawer>
    </>
  );
};

export default ProductionTablemain;
